'use strict';

var BaseModal = require('./Modal/BaseModal');
var ImmediateRequest = require('../AjaxAPI/ImmediateRequest');
var WidgetUtils = require('./WidgetUtils');
var EventsHandler = require('../Events/EventsHandler');
WidgetUtils.requireStylesheet('MITS.Widgets.FadeOutModal');

var FadeOutModal = function() {
    this.initialize();
};

/**
 * This improves upon the base modal by modifying the activate function to
 * take a URL which will be displayed in the modal.  Also support is added
 * for firing events when the modal is closed, and to have the modal indicate
 * when it is busy loading content.
 *
 * Ironically, the FadeOutModal doesn't contain any code related to fading in or out.
 * That functionality is provided for us in the BaseModal that we extend.
 */
jQuery.extend(jQuery.extend(FadeOutModal.prototype, BaseModal.prototype), {
    method: 'post',
    closeEvents: null,
    loading: false,

    oldLocation: null,
    url: null,
    formData: null, //Serialized string
    
    /*
        Public Getters / Setters
    */
    getContentContainer: function() {
        return this.$modalContent.get(0);
    },

    getUrl: function() {
        return this.url;
    },

    setMethod: function(method) {
        this.method = method;
    },

    setFormData: function(formData) {
        this.formData = formData;
    },

    /*
        Public Methods
    */
    initialize: function() {
        this.closeEvents = new EventsHandler();

        this._loadMarkupOnLoad();
    },

    activate: function(url, className, retries) {
        try {
            if (url) {
                this.url = url;
            }

            //calls the super._activate which will call our _getContent function
            this._activate();
        } catch (e) {
            if(!retries || retries <= 3) {
                setTimeout(MITS.Util.curry(this.activate.bind(this), url, className, retries ? retries + 1 : 1), 500);
            }
        }
    },

    // Note this calls the closeEvents, but the close() method does not.  I would like to get rid of this distinction but it
    // would require touching Report which we can't do right now.  Instead I've changed uses of .close() to .deactivate()
    // in Discover, and cleared out the closeEvents before calling it in the one place it mattered.
    deactivate: function() {
        if(this.modalDisplayed) {
            if(this.closeEvents.getEvents().length > 0){
                this.closeEvents.executeEvents();
                this.closeEvents = new EventsHandler();

                if(!this.loading) {
                    this.close();
                }
                this.loading = false;
            } else {
                this.close();
            }
        }
    },

    /**
     * Sometimes a modal wants to refresh the page it is displayed on top of, such
     * as when you close the generic ajax-exception modal. In most cases, it's OK
     * to simply reload the current URL.  But sometimes, the parent page may want
     * to override this function to do special reload logic.  For example, if the
     * parent page is actually a dummy page whose only purpose is to launch a modal,
     * then a refresh should probably return the user to the previous non-dummy page.
     * Or if the URL has a URL parameter that was supposed to trigger a one-time action,
     * such as highlighting a newly created item.  Then refresh logic would reload the URL
     * without that one-time URL parameter.
     */
    reloadParentPage: function() {
        var url = document.location.href;
        if(url.lastIndexOf('#') === url.length - 1){
            url = url.substring(0, url.length - 1);
        }
        document.location = url;
    },

    updateContent: function(url) {
        if (url) {
            this.url = url;
        }
        this._getContent();
    },
    
    /**
     * just like updateContent but without clearing the contents or putting up a loading message
     */
    updateContentFast: function(url) {
        if (url) {
            this.url = url;
        }
        new ImmediateRequest(this.url, this.getContentContainer(), {
            method: this.method,
            completeEvents: [this.hideLoading.bind(this)]
        });
    },

    showLoading: function() {
        this.$modalContent.removeClass('loaded');
        this.$modalContent.addClass('loading');
    },

    hideLoading: function() {
        this.$modalContent.removeClass('loading');
        this.$modalContent.addClass('loaded');
    },

    addCloseEvent: function(func) {
        this.closeEvents.addEvent(func);
    },

    toString: function(){
        return '[FadeOutModal]';
    },

    /**
     *  reset to original size
     */
    resetModal: function(){
        this._setSizeDefault();
    },

    /**
     * Call this to set the modal to a width of 300px. It'll reset itself when deactivated but you can use resetModal
     * explicitly to reset if the different pages of your wizard are different sizes.
     * <b>Important</b> ensure that you close any resized modals using <code>MITS.getCurrentModal().deactivate();</code>
     * rather than <code>MITS.getCurrentModal().close();</code> because close does not call the closeEvents, but deactivate does.
     */
    resizeModalToSmall: function() {
        this._setSizeSmall();
        this._scheduleResetSizeOnClose();
    },

    /**
     * Call this to set the modal to a width of 600px. This is the default width, so it won't reset itself when deactivated.
     */
    resizeModalToDefault: function() {
        this._setSizeDefault();
    },

    /**
     * Call this to set the modal to a width of 900px. It'll reset itself when deactivated but you can use resetModal
     * explicitly to reset if the different pages of your wizard are different sizes.
     * <b>Important</b> ensure that you close any resized modals using <code>MITS.getCurrentModal().deactivate();</code>
     * rather than <code>MITS.getCurrentModal().close();</code> because close does not call the closeEvents, but deactivate does.
     */
    resizeModalToLarge: function() {
        this._setSizeLarge();
        this._scheduleResetSizeOnClose();
    },

    _scheduleResetSizeOnClose: function() {
        var resetOnClose = function(){
            this.closeEvents.removeEvent(resetOnClose);
            this.resetModal();
        };
        
        this.addCloseEvent(resetOnClose.bind(this));
    },
    
    /*
        Private Methods
     */
    
    _getContent: function() {
        this.showLoading();

        this.$modalContent.html('<div class="modal-body"></div>');

        var serializedForm = this.formData;
        //Assume the form data is only valid for a single time the modal loads and don't try
        //to resend the same data
        this.formData = null;

        new ImmediateRequest(this.url, this.getContentContainer(), {
            method: this.method,
            parameters: serializedForm,
            completeEvents: [this.hideLoading.bind(this), this._setTouchstartListener]
        });
    },
    
    _setTouchstartListener: function(){
        var $modalMainContent = jQuery('.modalMainContent');
        if ($modalMainContent.length) {
            $modalMainContent.on('touchstart', function () {
            });
        }
    }
    
});

module.exports = FadeOutModal;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/FadeOutModal.js
// module id = 20
// module chunks = 0